<template>
  <div class="bg-surface-canvas dark:bg-surface-level-900 h-screen overflow-hidden relative">
    <LandingMobileNavDrawer placement="fixed" />

    <slot />
  </div>
</template>
